import gql from "graphql-tag";

export default gql`
	query CompanyScopeAudits($company_id: String!) {
		CompanyScopeAudits(company_id: $company_id) {
			id
			company_id
			approved_at
		}
	}
`;
